<template>
  <v-container fluid class="fill-height d-block">
    <div class="pa-2 fill-height d-flex flex-column">
      <v-data-table
        fixed-header
        :headers="$t('panel.businesses.businessesList.gateway.table.header')"
        :items="tableData"
        item-key="id"
        :loading="loading"
        loading-text="Loading... Please wait"
        hide-default-footer
        :class="shortList"
      >
        <template v-slot:item.userName="{ item }">
          <router-link
            :to="{
              name: 'businesses',
              query: { userId: item.userId }
            }"
            >{{ item.userName }}</router-link
          >
        </template>
        <template v-slot:item.registerDate="{ item }">
          <div class="text-no-wrap">
            {{ item.insertDate | $renderDate }}
          </div>
        </template>
        <template v-slot:item.lastUpdate="{ item }">
          <div class="text-no-wrap">{{ item.modifyDate | $renderDate }}</div>
        </template>
        <template v-slot:item.gatewayStatus="{ item }">
          <v-chip
            class="transaction-status"
            label
            :color="$transactionStatusColor(item.gatewayStatus).color"
            :text-color="$transactionStatusColor(item.gatewayStatus).textColor"
          >
            {{ item.gatewayStatus }}
          </v-chip>
        </template>
        <template v-slot:item.currencies="{ item }">
          <router-link
            :to="{
              name: 'gatewaysDetails',
              params: { gatewayId: item.id }
            }"
          >
            {{
              $t(
                "panel.businesses.businessesList.gateway.table.content.currencies"
              )
            }}
          </router-link>
        </template>
        <template v-slot:item.gatewayInfo="{ item }">
          <v-btn
            v-if="item.gatewayStatus === 'ACTIVE'"
            small
            color="primary"
            text
            @click="resendModal(item.id)"
            class="text-decoration-underline font-medium-12 Btn-in-table"
          >
            {{
              $t(
                "panel.businesses.businessesList.gateway.table.content.gatewayInfo"
              )
            }}
          </v-btn>
        </template>
        <template v-slot:item.activities="{ item }">
          <div v-if="item.gatewayStatus === 'ACTIVE'">
            <v-btn
              small
              color="error"
              text
              :loading="submitLoading[item.id] || false"
              @click="
                openChangeStatusModal(
                  item.id,
                  'SUSPENDED',
                  item.gatewayType === 'POS' ? 'POS device' : 'WEB'
                )
              "
              class="text-decoration-underline font-medium-12 Btn-in-table"
            >
              {{
                $t(
                  "panel.businesses.businessesList.gateway.table.content.suspend"
                )
              }}
            </v-btn>
            <v-btn
              small
              color="warning"
              text
              :loading="submitLoading[item.id] || false"
              @click="
                openChangeStatusModal(
                  item.id,
                  'INACTIVE',
                  item.gatewayType === 'POS' ? 'POS device' : 'WEB'
                )
              "
              class="text-decoration-underline font-medium-12 Btn-in-table"
            >
              {{
                $t(
                  "panel.businesses.businessesList.gateway.table.content.deactivate"
                )
              }}
            </v-btn>
          </div>
          <div
            v-else-if="
              item.gatewayStatus === 'PENDING' ||
                item.gatewayStatus === 'INACTIVE'
            "
          >
            <v-btn
              small
              color="success"
              text
              :loading="submitLoading[item.id] || false"
              @click="openActivationModal(item)"
              class="text-decoration-underline font-medium-12 Btn-in-table"
            >
              {{
                $t(
                  "panel.businesses.businessesList.gateway.table.content.activate"
                )
              }}
            </v-btn>
            <v-btn
              small
              color="error"
              text
              :loading="submitLoading[item.id] || false"
              @click="
                openChangeStatusModal(
                  item.id,
                  'SUSPENDED',
                  item.gatewayType === 'POS' ? 'POS device' : 'WEB'
                )
              "
              class="text-decoration-underline font-medium-12 Btn-in-table"
            >
              {{
                $t(
                  "panel.businesses.businessesList.gateway.table.content.suspend"
                )
              }}
            </v-btn>
          </div>
        </template>
        <template v-slot:item.description="{ item }">
          <v-tooltip bottom color="primary">
            <template v-slot:activator="{ on, attrs }">
              <span class="table-text-overflow" v-bind="attrs" v-on="on">
                {{ item.description }}
              </span>
            </template>
            <span>{{ item.description }}</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </div>
    <v-dialog v-model="resendModalActivity" max-width="550px">
      <div class="px-8 py-5">
        <v-card-text class="font-medium-16 gray10--text text-center pa-1">{{
          $t("panel.businesses.businessesList.gateway.modal.gatewayInfo.title")
        }}</v-card-text>
        <v-btn
          color="primary"
          class="mt-5 mb-1 font-medium-16 fill-width py-6"
          @click="resendGatewayInfo"
          :loading="resendLoading"
        >
          {{
            $t(
              "panel.businesses.businessesList.gateway.modal.gatewayInfo.button"
            )
          }}
        </v-btn>
      </div>
    </v-dialog>
    <v-dialog
      v-model="activationModal"
      max-width="450px"
      @click:outside="closeActiveModal"
    >
      <v-btn icon :ripple="false" @click="closeActiveModal">
        <v-icon size="24">mdi-close</v-icon>
      </v-btn>

      <v-form ref="form" @submit.prevent="activatePos" class="pa-6">
        <v-text-field
          autofocus
          v-model="serialNumber"
          :label="$t('panel.posManagementPage.activationModal.serialNumber')"
          class="fill-width"
          outlined
          hide-details
        />

        <v-btn
          color="primary"
          class="py-6 font-semiBold-16 mt-8"
          depressed
          block
          type="submit"
        >
          {{ $t("panel.posManagementPage.activationModal.submit") }}
        </v-btn>
      </v-form>
    </v-dialog>

    <v-dialog
      v-model="changeStatusModal"
      max-width="450px"
      @click:outside="closeChangeStatusModal"
    >
      <v-btn icon :ripple="false" @click="closeChangeStatusModal">
        <v-icon size="24">mdi-close</v-icon>
      </v-btn>

      <v-form ref="changeStatus" @submit.prevent="changeStatus" class="pa-6">
        <div class="font-semiBold-16 text-center mb-3">
          {{
            $t("panel.posManagementPage.changeStatusModal.suspendCaution", {
              action: actionModalText,
              gatewayType: gatewayType
            })
          }}
        </div>

        <v-textarea
          autofocus
          v-model="changeStatusDescription"
          :rules="rules"
          required
          :label="$t('panel.posManagementPage.changeStatusModal.description')"
          class="fill-width"
          outlined
          rows="4"
          auto-grow
        />

        <v-btn
          color="error"
          class="py-6 font-semiBold-16 mt-5"
          depressed
          block
          type="submit"
        >
          {{ $t("panel.posManagementPage.changeStatusModal.confirm") }}
        </v-btn>
      </v-form>
    </v-dialog>

    <!--    <v-dialog v-model="suspendModalActivity" max-width="550px">-->
    <!--      <div>-->
    <!--        <v-form-->
    <!--          @submit.prevent="suspendGateway"-->
    <!--          class="d-flex flex-column justify-space-around align-center pa-7"-->
    <!--        >-->
    <!--          <v-text-field-->
    <!--            v-model="suspensionDescription"-->
    <!--            :label="-->
    <!--              $t('panel.businesses.businessesList.gateway.modal.action.label')-->
    <!--            "-->
    <!--            class="fill-width"-->
    <!--            outlined-->
    <!--            hide-details-->
    <!--          />-->

    <!--          <v-btn-->
    <!--            color="primary"-->
    <!--            class="fill-width py-6 font-semiBold-16 mt-10"-->
    <!--            type="submit"-->
    <!--          >-->
    <!--            {{-->
    <!--              $t("panel.businesses.businessesList.gateway.modal.action.button")-->
    <!--            }}-->
    <!--          </v-btn>-->
    <!--        </v-form>-->
    <!--      </div>-->
    <!--    </v-dialog>-->
  </v-container>
</template>

<script>
import { merchantService, gatewayService } from "@/services";
import renderDate from "@/mixins/renderDate";
import tableStatusItemColor from "@/mixins/tableStatusItemColor";
import gatewayModalsActions from "@/mixins/gatewayModalsActions";

export default {
  name: "gateway-list",
  mixins: [renderDate, tableStatusItemColor, gatewayModalsActions],
  props: ["businessId"],
  data() {
    return {
      loading: false,
      tableData: [],
      resendModalActivity: false,
      clickedGatewayId: "",
      // suspendModalActivity: false,
      // suspensionDescription: "",
      shortList: false,
      filtersObj: {},
      resendLoading: false
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    filtersSubmission() {
      this.loadData();
    },
    // suspendGateway() {
    //   this.suspendModalActivity = false;
    //   console.log(
    //     "submit suspension",
    //     this.clickedGatewayId,
    //     this.suspensionDescription
    //   );
    // },
    // suspendModal(item) {
    //   this.suspendModalActivity = true;
    //   this.clickedGatewayId = item;
    // },
    resendGatewayInfo() {
      this.resendLoading = true;
      gatewayService
        .reSendGatewayData(this.clickedGatewayId)
        .then(() => {
          this.resendModalActivity = false;
          this.$toast.success(
            this.$t("panel.businesses.businessesList.gateway.successMsgToast")
          );
        })
        .finally(() => (this.resendLoading = false));
    },
    resendModal(id) {
      this.resendModalActivity = true;
      this.clickedGatewayId = id;
    },
    loadData() {
      this.loading = true;
      merchantService
        .getGateway(this.businessId)
        .then(response => {
          this.tableData = response.data.data;
          const tableDataLength = this.tableData.length;
          if (tableDataLength < 5 && tableDataLength > 0) {
            if (tableDataLength === 1) {
              this.shortList = "short-list-one-item";
            } else this.shortList = "short-list";
          } else this.shortList = "";
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped lang="scss">
@import "GatewayList";
</style>
